import { z } from 'zod';
import { LANGUAGES, THEMES } from '../constants';
import { text } from './common';

export const patchMeSchema = z
  .object({
    language: z.enum(LANGUAGES).optional(),
    theme: z.enum(THEMES).optional(),
    displayName: text(1, 64).optional(),
  })
  .refine((v) => Object.keys(v).length > 0, 'Provide at least one field');
export type PatchMeBody = z.infer<typeof patchMeSchema>;

export const userTotpConfirmSchema = z.object({
  code: z.string().regex(/^\d{6}$/, 'Code must be 6 digits'),
});
export type UserTotpConfirmBody = z.infer<typeof userTotpConfirmSchema>;

export const disableTotpSchema = z.object({
  password: z.string().min(1).max(128),
  code: z.string().trim().min(6).max(20),
});
export type DisableTotpBody = z.infer<typeof disableTotpSchema>;

export const kycSchema = z.object({
  fullName: text(2, 100),
  idNumber: z
    .string()
    .trim()
    .min(4)
    .max(32)
    .regex(/^[A-Za-z0-9\-/]+$/, 'ID number may contain letters, digits, "-" and "/"'),
});
export type KycBody = z.infer<typeof kycSchema>;
